import React from 'react';
import Header from '../components/Header';
import List from '../components/List';
import Success from '../components/Success';

const Coming = ({ customers, getDatas, successList, addSuccess, removeSuccess, editSuccess, clearDatas }) => {
  return (
    <>

      <Header getDatas={getDatas} />

      <main className='coming'>
        <h2>
          Réservations à venir
        </h2>

        <List customers={customers} getDatas={getDatas} addSuccess={addSuccess} clearDatas={clearDatas} />

        <ul className='success-list'>
          {
            successList?.map((success, index) => (
              <Success success={success} key={index} id={index + 1} removeSuccess={removeSuccess} editSuccess={editSuccess} />
            ))
          }
        </ul>
      </main>
    </>
  );
};

export default Coming;